import React, { Fragment, Dispatch, useEffect, useState } from "react";
import { useHistory } from 'react-router-dom';
import { useDispatch, useSelector } from "react-redux";
import Button from '@material-ui/core/Button';
import Snackbar from '../../common/components/CreatedEnquirySnackbar';
import TextField from "@material-ui/core/TextField";
import MenuItem from "@material-ui/core/MenuItem";
import NotificationIcon from "../../common/components/NotificationIcon";
import FullscreenLoader from "../../common/components/FullscreenLoader";
import { Tab, Tabs, Box } from "@material-ui/core";
import { withStyles, Theme, createStyles, createTheme } from '@material-ui/core/styles';
import Switch from '@material-ui/core/Switch';
import { ThemeProvider } from '@material-ui/styles';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import { getAllDefaultTargetData } from "../../store/actions/superAdmin.actions";
import { superAdminServices } from "../../services/superAdmin.service";
import { Prompt } from "react-router-dom"
import { getYears } from "../../helpers/commonmethod";
import Alert from '@material-ui/lab/Alert';
import { viewCreditDealer } from "../../store/actions/dealer.action";

const AntSwitch = withStyles((theme: Theme) =>
  createStyles({
    root: {
      width: 60,
      height: 28,
      padding: 0,
    },
    switchBase: {
      padding: 5,
      color: '#FFFFFF',
    },
    thumb: {
      width: 17,
      height: 17,
    },
    track: {
      background: '#444444',
      opacity: '1 !important',
      borderRadius: '2rem',
      position: 'relative',
      '&:before, &:after': {
        display: 'inline-block',
        position: 'absolute',
        top: '50%',
        width: '50%',
        transform: 'translateY(-50%)',
        color: '#FFFFFF',
        textAlign: 'center',
        fontSize: 10,
        fontFamily: 'Nunito',
        fontWeight: 500
      },
      '&:before': {
        content: '"Yes"',
        left: 7,
        opacity: 0,
      },
      '&:after': {
        content: '"No"',
        right: 6,
      },
    },
    checked: {
      '&$switchBase': {
        color: '#FFFFFF',
        transform: 'translateX(33px)',
      },
      '& $thumb': {
        backgroundColor: '#FFFFFF',
      },
      '& + $track': {
        '&:before': {
          opacity: 1,
        },
        '&:after': {
          opacity: 0,
        }
      },
    },
  }),
)(Switch);

const theme = createTheme({
  palette: {
    primary: {
      main: '#1A9FE0'
    },
  },
});

interface TabPanelProps {
  children?: React.ReactNode;
  index: any;
  value: any;
}

function TabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`wrapped-tabpanel-${index}`}
      aria-labelledby={`wrapped-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box p={3}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

function a11yProps(index: number) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}

const ViewTargetDealer: React.FC = () => {
  const dispatch: Dispatch<any> = useDispatch();
  const history = useHistory();
  const leftMenuVisibility: any = useSelector(
    (state: any) => state.global && state.global.sideMenuOpened);
  const [value, setValue] = React.useState(0);
  const { getDefaultTargetDetails, updateDefaultTarget }: any = useSelector((state: any) => state.superAdmin);
  const { viewTargetDealer } = useSelector((state: any) => state.dealer)
  const { getCustomerDetails }: any = useSelector((state: any) => state.superAdmin);
  const { selectedNewDealer }: any = useSelector((state: any) => state.dealer);
  const sapCustomerId: any = selectedNewDealer && selectedNewDealer.sapCustomerId;

  const currencies = ["AED"];
  const [dataUpdated, setDataUpdated] = React.useState<any>(false);
  const [openErrorSnackbar, setOpenErrorSnackbar] = React.useState(false);
  const [successMessage, setSuccessMessage] = React.useState<any>(null);
  const [errorMessage, showErrorMessage] = React.useState<any>(null);

  const [openSnackbar, setOpenSnackbar] = React.useState(false);
  const webApplicationLoginId = sessionStorage.getItem('webApplicationLoginId') || '';
  const [error, setError] = React.useState<any>(null);
  const [selectYear, setSelectYear] = React.useState<any>(new Date().getFullYear());
  const [selectYearError, setSelectYearError] = React.useState<boolean>(false);
  const [invalidDate, setInvalidDate] = React.useState<boolean>(false);
  const [selectedTab, setselectedTab] = React.useState(0);
  const [isEdit, setIsEdit] = React.useState(false);
  const [selectedTabData, setSelectedTabData] = React.useState<any>(null);
  const [loading, setLoading] = React.useState<any>(false);
  const [disableMonths, setDisableMonth] = React.useState<any>({});
  const [dataUpdatedPrompt, setDataUpdatedPrompt] = React.useState<boolean>(false)
  const [brandTarget, setBrandTarget] = useState<any>()
  const years = getYears();


  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
  };

  const handleopenCloseSnackbar = (open?: any) => {
    setOpenSnackbar(open ? true : false);
  };


  const handleopenCloseErrorSnackbar = (open?: any) => {
    setOpenErrorSnackbar(open ? true : false);
  };

  // useEffect(()=>{
  //   window.onbeforeunload =function (){
  //       return  history.push("/dealers")
  //   }
  //   return ()=>{
  //    window.onbeforeunload = null
  //   }
  // },[])



  useEffect(() => {
    if (getDefaultTargetDetails && getDefaultTargetDetails.data && getDefaultTargetDetails.data.data && getDefaultTargetDetails.data.data.plan.length > 0) {
      setSelectedTabData(getDefaultTargetDetails.data.data.plan[0])
    }
  }, [getDefaultTargetDetails])

  useEffect(() => {
    setSelectedTabData(viewTargetDealer && viewTargetDealer.data && viewTargetDealer.data.targetData && viewTargetDealer.data.targetData.brandTargets && viewTargetDealer.data.targetData.brandTargets.length >= 1 && viewTargetDealer.data.targetData.brandTargets[0])
  }, [viewTargetDealer])

  useEffect(() => {
    const month = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"]
    const currentMonth = new Date();
    const name = currentMonth.getMonth()
    const currentYear = new Date().getUTCFullYear()
    const filterMonth = month.filter((ele: any, i: any) => {
      return i < name
    })
    const disableMonth = { jan: false, feb: false, mar: false, apr: false, may: false, jun: false, jul: false, aug: false, oct: false, sep: false, nov: false, dec: false }
    if (filterMonth.includes(month[0])) {
      disableMonth.jan = true
    }
    if (filterMonth.includes(month[1])) {
      disableMonth.feb = true
    } if (filterMonth.includes(month[2])) {
      disableMonth.mar = true
    } if (filterMonth.includes(month[3])) {
      disableMonth.apr = true
    } if (filterMonth.includes(month[4])) {
      disableMonth.may = true
    } if (filterMonth.includes(month[5])) {
      disableMonth.jun = true
    } if (filterMonth.includes(month[6])) {
      disableMonth.jul = true
    } if (filterMonth.includes(month[7])) {
      disableMonth.aug = true
    } if (filterMonth.includes(month[8])) {
      disableMonth.sep = true
    } if (filterMonth.includes(month[9])) {
      disableMonth.oct = true
    } if (filterMonth.includes(month[10])) {
      disableMonth.nov = true
    } if (filterMonth.includes(month[11])) {
      disableMonth.dec = true
    }
    if (selectYear === currentYear) {
      setDisableMonth(disableMonth)
    } else if (selectYear <= currentYear) {
      setDisableMonth({ jan: true, feb: true, mar: true, apr: true, may: true, jun: true, jul: true, aug: true, oct: true, sep: true, nov: true, dec: true })
    } else if (selectYear >= currentYear) {
      setDisableMonth({ jan: false, feb: false, mar: false, apr: false, may: false, jun: false, jul: false, aug: false, oct: false, sep: false, nov: false, dec: false })
    }
  }, [selectYear])

  // FOR PUT API CALL - TO UPADTE SET TARGET DATA
  const setTargetApiCall = async () => {
    let value = getDefaultTargetDetails.data.data.plan;
    value[selectedTab] = selectedTabData;
    let data = {
      "updatedBy": webApplicationLoginId,
      "plan": value,
    }
    setLoading(true);
    const responseData = await superAdminServices.updateDefaultTarget(data, webApplicationLoginId, selectYear);
    if (responseData && responseData.message && responseData.message.status == "S") {
      setLoading(false);
      setDataUpdated(false);
      setOpenErrorSnackbar(false);
      setOpenSnackbar(true);
      setSuccessMessage(responseData.message.message);
    } else {
      setLoading(false);
      // setOpenErrorSnackbar(true);
      handleopenCloseErrorSnackbar(true);
      showErrorMessage(responseData.error ? responseData.error : "Something went Wrong");
    }
  }

  // FOR QUARTER 1 - TOTAL 
  const handleInputChange = () => {
    let jan = parseInt(selectedTabData?.monthlyTaget?.Jan?.amount || 0);
    let feb = parseInt(selectedTabData?.monthlyTaget?.Feb?.amount || 0);
    let mar = parseInt(selectedTabData?.monthlyTaget?.Mar?.amount || 0);
    let Q1 = jan + feb + mar
    let initialValue = selectedTabData
    initialValue.quarterlyTaget.quarter1.amount = Q1
    setSelectedTabData({ ...initialValue });
    handleInputChangeYaerlyTarget();
  }

  // FOR QUARTER 2 TARGET- TOTAL 
  const handleInputChangeQ2 = () => {
    let apr = parseInt(selectedTabData?.monthlyTaget?.Apr?.amount || 0);
    let may = parseInt(selectedTabData?.monthlyTaget?.May?.amount || 0);
    let june = parseInt(selectedTabData?.monthlyTaget?.Jun?.amount || 0);
    let Q2 = apr + may + june
    let initialValue = selectedTabData
    initialValue.quarterlyTaget.quarter2.amount = Q2
    setSelectedTabData({ ...initialValue });
    handleInputChangeYaerlyTarget();
  }

  // FOR QUARTER 3 TARGET- TOTAL 
  const handleInputChangeQ3 = () => {
    let jul = parseInt(selectedTabData?.monthlyTaget?.Jul?.amount || 0);
    let aug = parseInt(selectedTabData?.monthlyTaget?.Aug?.amount || 0);
    let sept = parseInt(selectedTabData?.monthlyTaget?.Sept?.amount || 0);
    let Q3 = jul + aug + sept
    let initialValue = selectedTabData
    initialValue.quarterlyTaget.quarter3.amount = Q3
    setSelectedTabData({ ...initialValue });
    handleInputChangeYaerlyTarget();
  }

  // FOR QUARTER 4 TARGET - TOTAL 
  const handleInputChangeQ4 = () => {
    let oct = parseInt(selectedTabData?.monthlyTaget?.Oct?.amount || 0);
    let nov = parseInt(selectedTabData?.monthlyTaget?.Nov?.amount || 0);
    let dec = parseInt(selectedTabData?.monthlyTaget?.Dec?.amount || 0);
    let Q4 = oct + nov + dec
    let initialValue = selectedTabData
    initialValue.quarterlyTaget.quarter4.amount = Q4
    setSelectedTabData({ ...initialValue });
    handleInputChangeYaerlyTarget();
  }

  // FOR YEARLY TARGET - TOTAL 
  const handleInputChangeYaerlyTarget = () => {
    let Q1 = parseInt(selectedTabData?.quarterlyTaget?.quarter1?.amount || 0);
    let Q2 = parseInt(selectedTabData?.quarterlyTaget?.quarter2?.amount || 0);
    let Q3 = parseInt(selectedTabData?.quarterlyTaget?.quarter3?.amount || 0);
    let Q4 = parseInt(selectedTabData?.quarterlyTaget?.quarter4?.amount || 0);
    let YearlyTargetTotal = Q1 + Q2 + Q3 + Q4;
    let initialValue = selectedTabData
    initialValue.yearlyTaget.amount = YearlyTargetTotal
    setSelectedTabData({ ...initialValue });
  }

  return (
    <Fragment>
      {loading && <FullscreenLoader />}
      {getDefaultTargetDetails && getDefaultTargetDetails.loading && <FullscreenLoader />}
      <Snackbar
        open={openSnackbar}
        handleopenClose={() => {
          handleopenCloseSnackbar(false)
        }} message={successMessage} />
      <Snackbar
        open={openErrorSnackbar}
        type="error"
        handleopenClose={() => {
          handleopenCloseErrorSnackbar(false)
        }} message={errorMessage} />
      <div className="d-flex align-items-center">
        <div className="d-flex flex-row">
          <h5 className="page-sub-title text-bold font-20 edit-font fontweight-superadmin-header mb-2">View Target  </h5>
          <div className="font-12 mt-3 pl-2 edit-font fontweight-superadmin">({getCustomerDetails && getCustomerDetails.data && getCustomerDetails.data.data && getCustomerDetails.data.data && getCustomerDetails.data.data.companyName} - {sessionStorage.getItem("sapid")})</div>
        </div>
        <div className="ml-auto"> <NotificationIcon /> </div>
      </div>
      <div className="d-flex align-items-center">
        View target for all brands
        <div className="ml-auto">
          <div className="pb-2 d-flex flex-row">
            <div className="ml-auto">
              <TextField select
                id="selectYear"
                label="Select Year"
                value={selectYear}
                variant="outlined"
                className="rounded-input-dealer mw-200p mr-2 mb-2"
                size="small"
                InputLabelProps={{
                  style: { color: '#000000' },
                }}
                onChange={(e: any) => {
                  setselectedTab(0);
                  setSelectYear(e.target.value);
                  dispatch(viewCreditDealer(sapCustomerId, e.target.value));
                }}
              >
                {years.map((data: any, index: any) => (
                  <MenuItem key={index} value={data}> {data} </MenuItem>
                ))}
              </TextField>
            </div>
            <Button className="float-right font-size-5 pl-0 addOrderEnqButton mb-4" onClick={() => {
              history.push("/dealers")
            }}><div className="px-2 pr-2 mt-0 font-color-dealer">Back</div></Button>
          </div>
        </div>
      </div>
      {viewTargetDealer && viewTargetDealer.data && viewTargetDealer.data.isTargetSet === true ? (
        <>
          <div className="row">
            <div className="mt-3 mb-3 pb-5 w-100">
              <ThemeProvider theme={theme}>
                <Paper square>
                  <Tabs
                    className="tabSelect border-bottom border-top-0"
                    value={selectedTab}
                    textColor="primary"
                    indicatorColor="primary"
                    onChange={(event, newValue) => {
                      setselectedTab(newValue)
                      setSelectedTabData(viewTargetDealer && viewTargetDealer.data && viewTargetDealer.data.targetData && viewTargetDealer.data.targetData.brandTargets && viewTargetDealer.data.targetData.brandTargets && viewTargetDealer.data.targetData.brandTargets[newValue])
                    }}
                    aria-label="basic tabs example">
                    {viewTargetDealer && viewTargetDealer.data && viewTargetDealer.data.targetData && viewTargetDealer.data.targetData.brandTargets && viewTargetDealer.data.targetData.brandTargets && viewTargetDealer.data.targetData.brandTargets.map((ele: any) => {
                      return (<Tab label={ele.displayName} />)
                    })}
                  </Tabs>
                  {selectedTabData && (
                    <TabPanel value={selectedTab} index={selectedTab}>
                      <div className="row p-2 m-0">
                        <div className="row col-sm-12 col-md-12 col-lg-8 mb-3 px-3 border-bottom border-top-0">
                          <div className="col-12 d-flex justify-content-between">
                            <div className="col-12 px-0"><h6 className="setTarget-monthly-target mb-2">Monthly Target</h6></div>
                          </div>
                          <div className="col-sm-4 col-md-4 col-lg-4 mb-2 pr-0">
                            <TextField id="currenciesValues"
                              value={selectedTabData?.monthlyTaget?.Jan?.currencyType}
                              disabled
                              defaultValue={currencies[0]}
                              size="small" className="col-sm-3 commonRoundedInputs-dropdown" variant="outlined" margin="dense">
                              {currencies.map(item => (
                                <MenuItem key={item} value={item}>{item}</MenuItem>))}
                            </TextField>
                            <TextField id="january"
                              type="number"
                              value={selectedTabData?.monthlyTaget?.Jan.amount || 0}
                              onKeyDown={(e: any) => ["e", "E", "+", "-"].includes(e.key) && e.preventDefault()}
                              onChange={(e: any) => {
                                let updateValue = parseInt(e.target.value || 0);
                                let initialValue = selectedTabData
                                initialValue.monthlyTaget.Jan.amount = updateValue
                                setSelectedTabData({ ...initialValue });
                                handleInputChange();
                                setDataUpdated(true)
                                setDataUpdatedPrompt(true)
                              }}
                              InputLabelProps={{
                                style: { color: '#000000' },
                              }}
                              size="small" className="col-sm-9 commonRoundedInputs-textfield"
                              label="January" variant="outlined" margin="dense" disabled={true} />
                          </div>
                          {/* )}  */}
                          <div className="col-sm-4 col-md-4 col-lg-4 mb-2 pr-0">
                            <TextField id="currenciesValues"
                              value={selectedTabData?.monthlyTaget?.Feb?.currencyType}
                              disabled
                              defaultValue={currencies[0]}
                              size="small" className="col-sm-3 commonRoundedInputs-dropdown" variant="outlined" margin="dense">
                              {currencies.map(item => (
                                <MenuItem key={item} value={item}>{item}</MenuItem>))}
                            </TextField>
                            <TextField
                              id="february"
                              type="number"
                              value={selectedTabData?.monthlyTaget?.Feb?.amount || 0}
                              onKeyDown={(e: any) => ["e", "E", "+", "-"].includes(e.key) && e.preventDefault()}
                              size="small" className="col-sm-9 commonRoundedInputs-textfield"
                              onChange={(e: any) => {
                                let updateValue = parseInt(e.target.value || 0);
                                let initialValue = selectedTabData
                                initialValue.monthlyTaget.Feb.amount = updateValue
                                setSelectedTabData({ ...initialValue });
                                handleInputChange();
                                setDataUpdated(true)
                                setDataUpdatedPrompt(true)
                              }}
                              InputLabelProps={{
                                style: { color: '#000000' },
                              }}
                              label="February" variant="outlined" margin="dense"
                              disabled={true}
                            />
                          </div>
                          <div className="col-sm-4 col-md-4 col-lg-4 mb-2 pr-3">
                            <TextField id="currenciesValues"
                              value={selectedTabData?.monthlyTaget?.Mar?.currencyType}
                              disabled
                              defaultValue={currencies[0]}
                              size="small" className="col-sm-3 commonRoundedInputs-dropdown" variant="outlined" margin="dense">
                              {currencies.map(item => (
                                <MenuItem key={item} value={item}>{item}</MenuItem>))}
                            </TextField>
                            <TextField id="march"
                              type="number"
                              value={selectedTabData?.monthlyTaget?.Mar?.amount || 0}
                              onChange={(e: any) => {
                                let updateValue = parseInt(e.target.value || 0);
                                let initialValue = selectedTabData
                                initialValue.monthlyTaget.Mar.amount = updateValue
                                setSelectedTabData({ ...initialValue });
                                setDataUpdated(true)
                                handleInputChange();
                                setDataUpdatedPrompt(true)
                              }}
                              InputLabelProps={{
                                style: { color: '#000000' },
                              }}
                              onKeyDown={(e: any) => ["e", "E", "+", "-"].includes(e.key) && e.preventDefault()}
                              size="small" className="col-sm-9 commonRoundedInputs-textfield"
                              label="March" variant="outlined" margin="dense" disabled={true} />
                          </div>
                        </div>
                        <div className="col-12 col-lg-4 col-md-12 col-sm-12 mb-3 px-3 border border-bottom border-right-0 border-top-0">
                          <div className="col-12 d-flex justify-content-between">
                            <div className="col-12"><h6 className="setTarget-quarter-target mb-2">Quarter 1 Target</h6></div>
                          </div>
                          <div className="col-sm-12 col-md-12 col-lg-12 pr-0">
                            <TextField
                              id="quarterCurrencies"
                              value={selectedTabData?.quarterlyTaget?.quarter1?.currencyType}
                              defaultValue={currencies[0]}
                              disabled
                              size="small" className="col-sm-3 commonRoundedInputs-dropdown" variant="outlined" margin="dense">
                              {currencies.map(item => (
                                <MenuItem key={item} value={item}>{item}</MenuItem>))}
                            </TextField>
                            <TextField id="quarterOne"
                              type="number"
                              value={selectedTabData?.quarterlyTaget?.quarter1?.amount || 0}
                              onKeyDown={(e: any) => ["e", "E", "+", "-"].includes(e.key) && e.preventDefault()}
                              disabled={true}
                              onChange={(e: any) => {
                                let updateValue = parseInt(e.target.value || 0);
                                let initialValue = selectedTabData
                                initialValue.quarterlyTaget.quarter1.amount = updateValue
                                setSelectedTabData({ ...initialValue });
                                setDataUpdatedPrompt(true);
                                handleInputChangeYaerlyTarget();
                              }}
                              InputLabelProps={{
                                style: { color: '#000000' },
                              }}
                              size="small" className="col-sm-9 commonRoundedInputs-textfield"
                              label="Quarter 1" variant="outlined" margin="dense" />
                          </div>
                        </div>
                        <div className="row col-sm-12 col-md-12 col-lg-8 mb-3 px-3 border-bottom border-top-0">
                          <div className="col-12 d-flex justify-content-between">
                            <div className="col-12 px-0"><h6 className="setTarget-monthly-target mb-2">Monthly Target</h6></div>
                          </div>
                          <div className="col-sm-4 col-md-4 col-lg-4 mb-2 pr-0">
                            <TextField id="currenciesValues"
                              value={selectedTabData?.monthlyTaget?.Apr?.currencyType}
                              disabled
                              defaultValue={currencies[0]}
                              size="small" className="col-sm-3 commonRoundedInputs-dropdown" variant="outlined" margin="dense">
                              {currencies.map(item => (
                                <MenuItem key={item} value={item}>{item}</MenuItem>))}
                            </TextField>
                            <TextField id="april"
                              type="number"
                              value={selectedTabData?.monthlyTaget?.Apr?.amount || 0}
                              onChange={(e: any) => {
                                let updateValue = parseInt(e.target.value || 0);
                                let initialValue = selectedTabData
                                initialValue.monthlyTaget.Apr.amount = updateValue
                                setSelectedTabData({ ...initialValue });
                                setDataUpdated(true)
                                setDataUpdatedPrompt(true)
                                handleInputChangeQ2();
                              }}
                              InputLabelProps={{
                                style: { color: '#000000' },
                              }}
                              onKeyDown={(e: any) => ["e", "E", "+", "-"].includes(e.key) && e.preventDefault()}
                              size="small" className="col-sm-9 commonRoundedInputs-textfield"
                              label="April" variant="outlined" margin="dense" disabled={true} />
                          </div>
                          <div className="col-sm-4 col-md-4 col-lg-4 mb-2 pr-0">
                            <TextField id="currenciesValues"
                              value={selectedTabData?.monthlyTaget?.May?.currencyType}
                              disabled
                              defaultValue={currencies[0]}
                              size="small" className="col-sm-3 commonRoundedInputs-dropdown" variant="outlined" margin="dense">
                              {currencies.map(item => (
                                <MenuItem key={item} value={item}>{item}</MenuItem>))}
                            </TextField>
                            <TextField id="may"
                              type="number"
                              value={selectedTabData?.monthlyTaget?.May?.amount || 0}
                              onChange={(e: any) => {
                                let updateValue = parseInt(e.target.value || 0);
                                let initialValue = selectedTabData
                                initialValue.monthlyTaget.May.amount = updateValue
                                setSelectedTabData({ ...initialValue });
                                setDataUpdated(true)
                                setDataUpdatedPrompt(true)
                                handleInputChangeQ2();
                              }}
                              InputLabelProps={{
                                style: { color: '#000000' },
                              }}
                              onKeyDown={(e: any) => ["e", "E", "+", "-"].includes(e.key) && e.preventDefault()}
                              size="small" className="col-sm-9 commonRoundedInputs-textfield"
                              label="May" variant="outlined" margin="dense" disabled={true} />
                          </div>
                          <div className="col-sm-4 col-md-4 col-lg-4 mb-2 pr-3">
                            <TextField id="currenciesValues"
                              value={selectedTabData?.monthlyTaget?.Jun?.currencyType}
                              disabled
                              defaultValue={currencies[0]}
                              size="small" className="col-sm-3 commonRoundedInputs-dropdown" variant="outlined" margin="dense" >
                              {currencies.map(item => (
                                <MenuItem key={item} value={item}>{item}</MenuItem>))}
                            </TextField>
                            <TextField id="june"
                              type="number"
                              value={selectedTabData.monthlyTaget.Jun.amount || 0}
                              onChange={(e: any) => {
                                let updateValue = parseInt(e.target.value || 0);
                                let initialValue = selectedTabData
                                initialValue.monthlyTaget.Jun.amount = updateValue
                                setSelectedTabData({ ...initialValue });
                                setDataUpdated(true)
                                setDataUpdatedPrompt(true)
                                handleInputChangeQ2();
                              }}
                              InputLabelProps={{
                                style: { color: '#000000' },
                              }}
                              onKeyDown={(e: any) => ["e", "E", "+", "-"].includes(e.key) && e.preventDefault()}
                              size="small" className="col-sm-9 commonRoundedInputs-textfield"
                              label="June" variant="outlined" margin="dense" disabled={true} />
                          </div>
                        </div>
                        <div className="col-12 col-lg-4 col-md-12 col-sm-12 mb-3 px-3 border border-bottom border-right-0 border-top-0">
                          <div className="col-12 d-flex justify-content-between">
                            <div className="col-12"><h6 className="setTarget-quarter-target mb-2">Quarter 2 Target</h6></div>
                          </div>
                          <div className="col-sm-12 col-md-12 col-lg-12 mb-2 pr-0">
                            <TextField
                              id="quarterCurrencies"
                              value={selectedTabData?.quarterlyTaget?.quarter2?.currencyType}
                              disabled
                              defaultValue={currencies[0]}
                              size="small" className="col-sm-3 commonRoundedInputs-dropdown" variant="outlined" margin="dense">
                              {currencies.map(item => (
                                <MenuItem key={item} value={item}>{item}</MenuItem>))}
                            </TextField>
                            <TextField id="quarterTwo"
                              type="number"
                              value={selectedTabData.quarterlyTaget.quarter2.amount}
                              disabled={true}
                              onChange={(e: any) => {
                                let updateValue = parseInt(e.target.value || 0);
                                let initialValue = selectedTabData
                                initialValue.quarterlyTaget.quarter2.amount = updateValue
                                setSelectedTabData({ ...initialValue });
                                setDataUpdatedPrompt(true)
                                setDataUpdated(true)
                                handleInputChangeYaerlyTarget();
                              }}
                              InputLabelProps={{
                                style: { color: '#000000' },
                              }}
                              onKeyDown={(e: any) => ["e", "E", "+", "-"].includes(e.key) && e.preventDefault()}
                              size="small" className="col-sm-9 commonRoundedInputs-textfield"
                              label="Quarter 2" variant="outlined" margin="dense" />
                          </div>
                        </div>
                        <div className="row col-sm-12 col-md-12 col-lg-8 mb-3 px-3 border-bottom border-top-0">
                          <div className="col-12 d-flex justify-content-between">
                            <div className="col-12 px-0"><h6 className="setTarget-monthly-target mb-2">Monthly Target</h6></div>
                          </div>
                          <div className="col-sm-4 col-md-4 col-lg-4 mb-2 pr-0">
                            <TextField id="currenciesValues"
                              value={selectedTabData?.monthlyTaget?.Jul?.currencyType}
                              disabled
                              defaultValue={currencies[0]}
                              size="small" className="col-sm-3 commonRoundedInputs-dropdown" variant="outlined" margin="dense">
                              {currencies.map(item => (
                                <MenuItem key={item} value={item}>{item}</MenuItem>))}
                            </TextField>
                            <TextField id="july"
                              type="number"
                              value={selectedTabData?.monthlyTaget?.Jul?.amount || 0}
                              onKeyDown={(e: any) => ["e", "E", "+", "-"].includes(e.key) && e.preventDefault()}
                              onChange={(e: any) => {
                                let updateValue = parseInt(e.target.value || 0);
                                let initialValue = selectedTabData
                                initialValue.monthlyTaget.Jul.amount = updateValue
                                setSelectedTabData({ ...initialValue });
                                setDataUpdated(true)
                                setDataUpdatedPrompt(true)
                                handleInputChangeQ3();
                              }}
                              InputLabelProps={{
                                style: { color: '#000000' },
                              }}
                              size="small" className="col-sm-9 commonRoundedInputs-textfield"
                              label="July" variant="outlined" margin="dense" disabled={true} />
                          </div>
                          <div className="col-sm-4 col-md-4 col-lg-4 mb-2 pr-0">
                            <TextField id="currenciesValues"
                              value={selectedTabData?.monthlyTaget?.Aug?.currencyType}
                              disabled
                              defaultValue={currencies[0]}
                              size="small" className="col-sm-3 commonRoundedInputs-dropdown" variant="outlined" margin="dense">
                              {currencies.map(item => (
                                <MenuItem key={item} value={item}>{item}</MenuItem>))}
                            </TextField>
                            <TextField id="august"
                              type="number"
                              value={selectedTabData?.monthlyTaget?.Aug?.amount || 0}
                              onKeyDown={(e: any) => ["e", "E", "+", "-"].includes(e.key) && e.preventDefault()}
                              onChange={(e: any) => {
                                let updateValue = parseInt(e.target.value || 0);
                                let initialValue = selectedTabData
                                initialValue.monthlyTaget.Aug.amount = updateValue
                                setSelectedTabData({ ...initialValue });
                                setDataUpdated(true)
                                setDataUpdatedPrompt(true)
                                handleInputChangeQ3();
                              }}
                              InputLabelProps={{
                                style: { color: '#000000' },
                              }}
                              size="small" className="col-sm-9 commonRoundedInputs-textfield"
                              label="August" variant="outlined" margin="dense" disabled={true} />
                          </div>
                          <div className="col-sm-4 col-md-4 col-lg-4 mb-2 pr-3">
                            <TextField id="currenciesValues"
                              value={selectedTabData?.monthlyTaget?.Sept?.currencyType}
                              disabled
                              defaultValue={currencies[0]}
                              size="small" className="col-sm-3 commonRoundedInputs-dropdown" variant="outlined" margin="dense">
                              {currencies.map(item => (
                                <MenuItem key={item} value={item}>{item}</MenuItem>))}
                            </TextField>
                            <TextField id="september"
                              type="number"
                              value={selectedTabData?.monthlyTaget?.Sept?.amount || 0}
                              onKeyDown={(e: any) => ["e", "E", "+", "-"].includes(e.key) && e.preventDefault()}
                              onChange={(e: any) => {
                                let updateValue = parseInt(e.target.value || 0);
                                let initialValue = selectedTabData
                                initialValue.monthlyTaget.Sept.amount = updateValue
                                setSelectedTabData({ ...initialValue });
                                setDataUpdated(true)
                                setDataUpdatedPrompt(true)
                                handleInputChangeQ3();
                              }}
                              InputLabelProps={{
                                style: { color: '#000000' },
                              }}
                              size="small" className="col-sm-9 commonRoundedInputs-textfield"
                              label="September" variant="outlined" margin="dense" disabled={true} />
                          </div>
                        </div>
                        <div className="col-12 col-lg-4 col-md-12 col-sm-12 mb-3 px-3 border border-bottom border-right-0 border-top-0">
                          <div className="col-12 d-flex justify-content-between">
                            <div className="col-12"><h6 className="setTarget-quarter-target mb-2">Quarter 3 Target</h6></div>
                          </div>
                          <div className="col-sm-12 col-md-12 col-lg-12 mb-2 pr-0">
                            <TextField
                              id="quarterCurrencies"
                              value={selectedTabData?.quarterlyTaget?.quarter3?.currencyType}
                              disabled
                              defaultValue={currencies[0]}
                              size="small" className="col-sm-3 commonRoundedInputs-dropdown" variant="outlined" margin="dense">
                              {currencies.map(item => (
                                <MenuItem key={item} value={item}>{item}</MenuItem>))}
                            </TextField>
                            <TextField id="quarterThird"
                              type="number"
                              disabled={true}
                              value={selectedTabData?.quarterlyTaget?.quarter3?.amount}
                              onKeyDown={(e: any) => ["e", "E", "+", "-"].includes(e.key) && e.preventDefault()}
                              onChange={(e: any) => {
                                let updateValue = parseInt(e.target.value || 0);
                                let initialValue = selectedTabData
                                initialValue.quarterlyTaget.quarter3.amount = updateValue
                                setSelectedTabData({ ...initialValue });
                                setDataUpdatedPrompt(true)
                                handleInputChangeYaerlyTarget();
                              }}
                              InputLabelProps={{
                                style: { color: '#000000' },
                              }}
                              size="small" className="col-sm-9 commonRoundedInputs-textfield"
                              label="Quarter 3" variant="outlined" margin="dense" />
                          </div>
                        </div>
                        <div className="row col-sm-12 col-md-12 col-lg-8 mb-3 px-3 border-bottom border-top-0">
                          <div className="col-12 d-flex justify-content-between">
                            <div className="col-12 px-0"><h6 className="setTarget-monthly-target mb-2">Monthly Target</h6></div>
                          </div>
                          <div className="col-sm-4 col-md-4 col-lg-4 mb-2 pr-0">
                            <TextField id="currenciesValues"
                              value={selectedTabData?.monthlyTaget?.Oct?.currencyType}
                              disabled
                              defaultValue={currencies[0]}
                              size="small" className="col-sm-3 commonRoundedInputs-dropdown" variant="outlined" margin="dense">
                              {currencies.map(item => (
                                <MenuItem key={item} value={item}>{item}</MenuItem>))}
                            </TextField>
                            <TextField id="october"
                              type="number"
                              value={selectedTabData?.monthlyTaget?.Oct?.amount || 0}
                              onKeyDown={(e: any) => ["e", "E", "+", "-"].includes(e.key) && e.preventDefault()}
                              onChange={(e: any) => {
                                let updateValue = parseInt(e.target.value || 0);
                                let initialValue = selectedTabData
                                initialValue.monthlyTaget.Oct.amount = updateValue
                                setSelectedTabData({ ...initialValue });
                                setDataUpdated(true)
                                setDataUpdatedPrompt(true)
                                handleInputChangeQ4();
                              }}
                              InputLabelProps={{
                                style: { color: '#000000' },
                              }}
                              size="small" className="col-sm-9 commonRoundedInputs-textfield"
                              label="October" variant="outlined" margin="dense" disabled={true} />
                          </div>
                          <div className="col-sm-4 col-md-4 col-lg-4 mb-2 pr-0">
                            <TextField id="currenciesValues"
                              value={selectedTabData?.monthlyTaget?.Nov?.currencyType}
                              disabled
                              defaultValue={currencies[0]}
                              size="small" className="col-sm-3 commonRoundedInputs-dropdown" variant="outlined" margin="dense">
                              {currencies.map(item => (
                                <MenuItem key={item} value={item}>{item}</MenuItem>))}
                            </TextField>
                            <TextField id="november"
                              type="number"
                              value={selectedTabData?.monthlyTaget?.Nov?.amount || 0}
                              onChange={(e: any) => {
                                let updateValue = parseInt(e.target.value || 0);
                                let initialValue = selectedTabData
                                initialValue.monthlyTaget.Nov.amount = updateValue
                                setSelectedTabData({ ...initialValue });
                                setDataUpdated(true)
                                setDataUpdatedPrompt(true)
                                handleInputChangeQ4();
                              }}
                              InputLabelProps={{
                                style: { color: '#000000' },
                              }}
                              onKeyDown={(e: any) => ["e", "E", "+", "-"].includes(e.key) && e.preventDefault()}
                              size="small" className="col-sm-9 commonRoundedInputs-textfield"
                              label="November" variant="outlined" margin="dense" disabled={true} />
                          </div>
                          <div className="col-sm-4 col-md-4 col-lg-4 mb-2 pr-3">
                            <TextField id="currenciesValues"
                              value={selectedTabData?.monthlyTaget?.Dec?.currencyType}
                              disabled
                              defaultValue={currencies[0]}
                              size="small" className="col-sm-3 commonRoundedInputs-dropdown" variant="outlined" margin="dense">
                              {currencies.map(item => (
                                <MenuItem key={item} value={item}>{item}</MenuItem>))}
                            </TextField>
                            <TextField id="december"
                              type="number"
                              value={selectedTabData?.monthlyTaget?.Dec?.amount || 0}
                              onKeyDown={(e: any) => ["e", "E", "+", "-"].includes(e.key) && e.preventDefault()}
                              onChange={(e: any) => {
                                let updateValue = parseInt(e.target.value || 0);
                                let initialValue = selectedTabData
                                initialValue.monthlyTaget.Dec.amount = updateValue
                                setSelectedTabData({ ...initialValue });
                                setDataUpdated(true)
                                setDataUpdatedPrompt(true)
                                handleInputChangeQ4();
                              }}
                              InputLabelProps={{
                                style: { color: '#000000' },
                              }}
                              size="small" className="col-sm-9 commonRoundedInputs-textfield"
                              label="December" variant="outlined" margin="dense" disabled={true} />
                          </div>
                        </div>
                        <div className="col-12 col-lg-4 col-md-12 col-sm-12 mb-3 px-3 border border-bottom border-right-0 border-top-0">
                          <div className="col-12 d-flex justify-content-between">
                            <div className="col-12"><h6 className="setTarget-quarter-target mb-2">Quarter 4 Target</h6></div>
                          </div>
                          <div className="col-sm-12 col-md-12 col-lg-12 mb-2 pr-0">
                            <TextField
                              id="quarterCurrencies"
                              value={selectedTabData?.quarterlyTaget?.quarter4?.currencyType}
                              disabled
                              defaultValue={currencies[0]}
                              size="small" className="col-sm-3 commonRoundedInputs-dropdown" variant="outlined" margin="dense">
                              {currencies.map(item => (
                                <MenuItem key={item} value={item}>{item}</MenuItem>))}
                            </TextField>
                            <TextField id="quarterFour"
                              type="number"
                              disabled={true}
                              value={selectedTabData?.quarterlyTaget?.quarter4?.amount}
                              onKeyDown={(e: any) => ["e", "E", "+", "-"].includes(e.key) && e.preventDefault()}
                              onChange={(e: any) => {
                                let updateValue = parseInt(e.target.value || 0);
                                let initialValue = selectedTabData
                                initialValue.quarterlyTaget.quarter4.amount = updateValue
                                setSelectedTabData({ ...initialValue });
                                setDataUpdatedPrompt(true)
                                handleInputChangeYaerlyTarget();
                              }}
                              InputLabelProps={{
                                style: { color: '#000000' },
                              }}
                              size="small" className="col-sm-9 commonRoundedInputs-textfield"
                              label="Quarter 4" variant="outlined" margin="dense" />
                          </div>
                        </div>
                        <div className="row col-sm-12 col-md-12 col-lg-8 mb-3 px-3">
                          <div className="col-12 d-flex justify-content-between"></div>
                          <div className="col-sm-12 col-md-4 col-lg-4 mb-2 pr-0"></div>
                          <div className="col-sm-8 col-md-8 col-lg-8 mb-2 pr-3"> </div>
                        </div>
                        <div className="col-12 col-lg-4 col-md-12 col-sm-12 mb-3 px-3 border border-bottom border-right-0 border-top-0">
                          <div className="col-12 d-flex justify-content-between">
                            <div className="col-12"><h6 className="setTarget-yearly-target mb-2">Yearly Target</h6></div>
                          </div>
                          <div className="col-sm-12 col-md-12 col-lg-12 mb-2 pr-0">
                            <TextField
                              id="quarterCurrencies"
                              value={selectedTabData?.yearlyTaget?.currencyType}
                              disabled
                              defaultValue={currencies[0]}
                              size="small" className="col-sm-3 commonRoundedInputs-dropdown" variant="outlined" margin="dense">
                              {currencies.map(item => (
                                <MenuItem key={item} value={item}>{item}</MenuItem>))}
                            </TextField>
                            <TextField id="yearlyTarget"
                              type="number"
                              value={selectedTabData?.yearlyTaget?.amount || 0}
                              onChange={(e: any) => {
                                let updateValue = parseInt(e.target.value || 0);
                                let initialValue = selectedTabData
                                initialValue.yearlyTaget.amount = updateValue
                                setSelectedTabData({ ...initialValue });
                                setDataUpdatedPrompt(true)
                              }}
                              InputLabelProps={{
                                style: { color: '#000000' },
                              }}
                              onKeyDown={(e: any) => ["e", "E", "+", "-"].includes(e.key) && e.preventDefault()}
                              size="small" className="col-sm-9 commonRoundedInputs-textfield"
                              label="Yearly" variant="outlined" margin="dense" disabled={true} />
                          </div>
                        </div>
                      </div>
                    </TabPanel>
                  )
                  }
                  {/* <div className={leftMenuVisibility ? "row card card-body p-2 fixed-bottom ml-280" : "row card card-body p-2 fixed-bottom ml-70"}>
                                <div className="col-12 d-flex mt-2 mb-2 p-0">
                                    <div className="col-6 px-4">
                                    </div>
                                    <div className="col-6 onboard-footer">
                                        <div className="">
                                            <Button
                                                variant="contained" color="primary"
                                                className={`blueActionButtonSave border-left rounded-pill mr-5 mt-2 mb-2`}
                                                onClick={() => { setTargetApiCall(); setDataUpdated(false);     
                                                }}
                                               >{dataUpdated ? 'Update' : 'Save'}
                                            </Button>
                                        </div>
                                    </div>
                                </div>
                            </div> */}
                </Paper>
              </ThemeProvider>
            </div>
          </div>
        </>
      ) : (
        <Alert severity="info">{viewTargetDealer && viewTargetDealer.data && viewTargetDealer.data.message}</Alert>
      )
      }
      {/* <Prompt when={dataUpdatedPrompt} message={"Do you wish to proceed without saving the data?"}></Prompt> */}
    </Fragment >
  );
};
export default ViewTargetDealer